import React, { FC, useState } from "react";
import BottomSlider from "../../components/BottomSlider/BottomSlider";
import Button, { ButtonModeE } from "../../components/Button/Button";
import Form from "../../components/Form/Form";
import Icon from "../../components/Icon/Icon";
import { H3, H4, P, Span } from "../../components/Text/Text";
import { FormFieldT } from "../../models/models";
import { shared } from "../../assets/images";
import { ValidatorsE } from "../../components/Form/yupValidations";
import { useShareVideoMutation } from "../../api/projectsApi";
import { toast } from "react-toastify";
import { TOAST_DURATION } from "../../utils/helpers/constants";

import styles from "./shareSlider.module.scss";
import { WhatsappShareButton } from "react-share";

type ShareSliderPropTypes = {
  showBottomSlider: boolean;
  toggleShow: () => void;
  handleShare: (data: any) => void;
  name: string;
  videoId?: number;
};

enum ShareTypeE {
  NONE,
  MAIL,
  WHATSAPP,
  DONE,
}

const supportPhoneNumber = "+380500000000";

const ShareSlider: FC<ShareSliderPropTypes> = (props) => {
  const [shareVideo] = useShareVideoMutation();
  const { showBottomSlider, toggleShow, handleShare, name, videoId } = props;
  const [shareType, setShareType] = useState(ShareTypeE.NONE);
  const fields: FormFieldT[] = [
    { label: "Email", validation: ValidatorsE.REQUIRED_STRING },
    {
      label: "Message",
      type: "textarea",
      orderIndex: 2,
      validation: ValidatorsE.REQUIRED_STRING,
    },
  ];

  const handleClose = () => {
    toggleShow();
    setTimeout(() => {
      setShareType(ShareTypeE.NONE);
    }, 300);
  };

  const handleSubmit = async (data: any) => {
    const body = {
      Email: data.email,
      ExtraText: data.message,
      Projecttype: "VideoAd",
    };
    try {
      await shareVideo({ videoId, ...body });
      toast("Successfully sent", {
        type: "success",
        autoClose: TOAST_DURATION,
      });
      handleClose();
    } catch (e: any) {
      console.log(e);
    }
  };

  return (
    <BottomSlider visible={showBottomSlider} onClose={handleClose}>
      <div className={styles.sliderWrapper}>
        {shareType === ShareTypeE.NONE && (
          <div>
            <H3 className={styles.sliderHeader}>Share {name}</H3>
            <div
              className={styles.shareItem}
              onClick={() => setShareType(ShareTypeE.MAIL)}
            >
              <Icon name="mailColor" />
              <Span>Share by email</Span>
            </div>
            {/*@ts-ignore*/}
            <WhatsappShareButton
              className={styles.shareItem}
              url={window.location.href}
              title="You got JUMBOMedia share!"
            >
              <Icon name="whatsappColor" />
              <Span>Share by Whatsapp</Span>
            </WhatsappShareButton>
          </div>
        )}
        {shareType === ShareTypeE.MAIL && (
          <div className={styles.shareSliderForm}>
            <H3 className={styles.sliderHeader}>Share {name}</H3>
            <Form
              fields={fields}
              formID="share-video-form"
              onSubmit={handleSubmit}
              columns={1}
              elements={
                <P style={{ order: 1 }} className={styles.hint}>
                  Add more addresses with commas.
                </P>
              }
            />
            <div className={styles.sliderButtons}>
              <Button form="share-video-form" onClick={handleSubmit}>
                Share
              </Button>
              <Button mode={ButtonModeE.OUTLINED} onClick={handleClose}>
                Cancel
              </Button>
            </div>
          </div>
        )}
        {shareType === ShareTypeE.DONE && (
          <div className={styles.shareDoneWrapper}>
            <img src={shared} alt="successful sharing" />
            <H4 className={styles.doneText}>Done!</H4>
            <P>{name} was successfully sent to the recipient by email</P>
          </div>
        )}
      </div>
    </BottomSlider>
  );
};

export default ShareSlider;
